<template>
	<div class="page">
		<div class="item" style="margin-bottom: 100px;height: 50px;">
			<input type="" class="ipt" placeholder="请输入需要转换成私钥的助记词" v-model="zjc" />
			<div class="btn" @click="encryptFN()">转换</div>
			<div class="cz" @click="chongzhi()" style="background-color: #909399;margin-left: 10px;">重置</div>
		</div>
		<div class="item">
			<span>地址：</span>
			<div class="content">{{ address }}</div>
			<div class="copy" @click="copyToClipboard('address')">复制</div>
		</div>
		<div class="item">
			<span>私钥：</span>
			<div class="content">{{ privateKey }}</div>
			<div class="copy" @click="copyToClipboard('privateKey')">复制</div>
		</div>
		<div class="item">
			<span>公钥：</span>
			<div class="content">{{ publicKey }}</div>
			<div class="copy" @click="copyToClipboard('publicKey')">复制</div>
		</div>
	</div>
</template>


<script>
	export default {
		name: 'HelloWorld',
		data() {
			return {
				zjc: '',
				privateKey: '',
				publicKey: '',
				address: ''
			}
		},
		methods: {
			copyToClipboard(type) {
				// 获取复制内容
				if (type === "address") {
					if (this.address == '' || this.address == null || this.address == undefined) {
						alert("复制失败！没有可复制的内容。")
						return
					}
				} else if (type === "privateKey") {
					if (this.privateKey == '' || this.privateKey == null || this.privateKey == undefined) {
						alert("复制失败！没有可复制的内容。")
						return
					}
				} else if (type === "publicKey") {
					if (this.publicKey == '' || this.publicKey == null || this.publicKey == undefined) {
						alert("复制失败！没有可复制的内容。")
						return
					}
				}
				let content = type === "address" ? this.address : type === "privateKey" ? this.privateKey : this.publicKey
				// 创建元素用于复制
				var aux = document.createElement("input");
				// 设置元素内容
				aux.setAttribute("value", content);
				// 将元素插入页面进行调用
				document.body.appendChild(aux);
				// 复制内容
				aux.select();
				// 将内容复制到剪贴板
				document.execCommand("copy");
				// 删除创建元素
				document.body.removeChild(aux);
				//提示
				alert("复制成功！");
			},
			async encryptFN() {
				if (this.zjc == '' || this.zjc == null || this.zjc == undefined) {
					alert("转换失败！没有可转换的内容。")
					return
				}
				try {
					let res = await window.tronWeb.fromMnemonic(this.zjc)
					this.privateKey = res.privateKey
					this.publicKey = res.publicKey
					this.address = res.address
				} catch (error) {
					console.log(error)
					alert("转换失败！请检查助记词内容是否正确")
				}

			},
			chongzhi() {
				this.privateKey = ''
				this.publicKey = ''
				this.address = ''
				this.zjc = ''
			}
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}

	.page {
		width: 100%;
		height: 100%;
		display: flex;
		flex-wrap: wrap;
		flex-direction: column;
		align-items: center;
		padding-top: 10%;
	}

	.item {
		width: 50%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.ipt {
		flex: 1;
		height: 100%;
		border-radius: 10px;
		padding: 0 20px;
		font-size: 20px;
	}

	.btn {
		width: 80px;
		height: 100%;
		background-color: #409EFF;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		font-size: 22px;
		margin-left: 20px;
		cursor: pointer;
	}

	.btn:hover {
		background-color: #2f79be;
	}

	.item span {
		font-weight: bold;
		font-size: 20px;
	}

	.content {
		flex: 1;
		max-width: 700px;
		word-wrap: break-word;
		border: 2px solid #777;
		color: #777;
		border-radius: 10px;
		padding: 20px;
		font-size: 20px;
		background-color: #f6f6f6;
		text-align: left;
		word-wrap: break-word;
	}

	.cz {
		width: 80px;
		height: 100%;
		background-color: #E6A23C;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		font-size: 22px;
		margin-left: 30px;
		cursor: pointer;
	}

	.copy {
		width: 100px;
		height: 40px;
		background-color: #E6A23C;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 6px;
		font-size: 18px;
		margin-left: 30px;
		cursor: pointer;
	}

	.copy:hover {
		background-color: #bc8430;
	}

	::-webkit-input-placeholder {
		color: #aaa;
	}
</style>